module.exports = __webpack_public_path__ + "static/media/six4.129a4c9e.svg";